import styled from '@emotion/styled';

export const TotalPriceOriginalContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 4px;

  [data-helptooltip] {
    svg {
      width: 16px;
      height: 16px;
    }
  }
`;
